/* global CONFIG */
// import moment from 'moment'
export default {
  getAllService (VueApp, callback) {
    VueApp.$sdk.get('/service', {
      token: VueApp.$store.state.session.sessionToken,
      all: 1
    }, r => {
      VueApp.$store.commit('pricing/clearServiceTypes')
      if (!r.error) {
        r.list.sort((a, b)  => { return a.id - b.id})
        r.list.forEach(service => {
          if (service.brandId) {
            let licenseType = []
            if (service.allowTNC) { licenseType.push('tnc') }
            if (service.allowTCP) { licenseType.push('tcp') }
            if (service.allowPSC) { licenseType.push('psc') }
            VueApp.$store.commit('pricing/addServiceTypes', {
              id: service.id,
              brandId: service.brandId,
              brandEnabled: service.enabled,
              name: service.name,
              label: service.label,
              code: service.code,
              priority: service.priority,
              isShared: service.isShared,
              licenseType: licenseType,
              maxPassenger: service.maxPassengers,
              maxLuggages: service.maxLuggages,
              isCharter: service.isCharter,
              isRental: service.isRental,
              maxConcurrent: service.maxConcurrent
            })
          }
        })
      }
      callback(r)
    }, '2.0')
  },
  setPriceSettings (VueApp, type, callback) {
    let self = this
    let serviceArea = VueApp.$store.state.pricing.serviceArea    
    VueApp.$sdk.post('/servicearea/' + serviceArea.activeId + '/pricing', self.buildPriceSettingsData(VueApp, type, false), r => {
      callback(r)
    }, '2.0')
  },
  setGlobalPriceSettings (VueApp, data, callback) {
    let self = this

    if (data.serviceArea.length > 0) {
      VueApp.$sdk.get('/servicearea/' + data.serviceArea[0] + '/pricing', {
        token: VueApp.$store.state.session.sessionToken,
        pageNum: 1,
        pageSize: 999
      }, res => {
        if (res.error) {
          callback(res)
          return
        }

        let enabledServices = []
        res.list.forEach(service => {
          if (service.enabled) enabledServices.push(service.serviceTypeId)
        })

        VueApp.$sdk.post('/servicearea/' + data.serviceArea[0] + '/pricing', self.buildPriceSettingsData(VueApp, data.type, true, enabledServices), res2 => {
          if (res2.error) {
            callback(res2)
          } else {
            data.serviceArea.shift()
            self.setGlobalPriceSettings(VueApp, data, callback)
          }
          return
        }, '2.0')
      }, '2.0')
    } else {
      callback('done')
    }
  },
  setGlobalServiceEnable (VueApp, data, callback) {
    let self = this
    let serviceTypes = VueApp.$store.state.pricing.serviceTypes
    let enableList = serviceTypes.enableList
    let disableList = serviceTypes.disableList

    if (!data.length) {
      callback('done')
      return
    }

    if (enableList.length > 0 || disableList.length > 0) {
      let services = []
      enableList.forEach(id => {
        services.push({ serviceTypeId: id, enabled: true })
      })
      disableList.forEach(id => {
        services.push({ serviceTypeId: id, enabled: false })
      })
      VueApp.$sdk.post('/servicearea/' + data[0] + '/pricing', {
        token: VueApp.$store.state.session.sessionToken,
        services: services
      }, res => {
        if (res.error) {
          callback(res)
        } else {
          data.shift()
          self.setGlobalServiceEnable(VueApp, data, callback)
        }
        return
      }, '2.0')
    } else {
      callback('done')
    }
  },
  buildPriceSettingsData (VueApp, type, forGlobal, serviceCheck = []) {
    let compiledData = {token: VueApp.$store.state.session.sessionToken}
    let services = []
    let pricingStore = VueApp.$store.state.pricing
    let serviceArea = pricingStore.serviceArea
    let tempServiceTypes = JSON.parse(JSON.stringify(pricingStore.serviceTypes.list))
    let temp = tempServiceTypes.filter(x => x.brandId === pricingStore.brandId && x.enabled && x.brandEnabled)
    if (type === 'charter') {
      temp = tempServiceTypes.filter(x => x.brandId === pricingStore.brandId && x.enabled && x.brandEnabled && x.isCharter)
    }
    if (forGlobal) {
      temp = temp.filter(x => serviceCheck.indexOf(x.id) > -1)
    }

    if (type === 'future') {
      temp.forEach((service, index) => {
        let tempService = service.future
        tempService.serviceTypeId = service.id

        let tempPickupTypes = []
        for (let key in service.pickupTypes) {
          if (key !== 'null' && key !== 'enabled') {
            if (temp[index].pickupTypes[key].fee !== '' && temp[index].pickupTypes[key].fee !== null) {
              let tempPickupType = temp[index].pickupTypes[key]
              if (forGlobal) {
                delete tempPickupType.enabled
              }
              tempPickupTypes.push(tempPickupType)
            }
          }
        }
        tempService.pickupTypes = tempPickupTypes
        tempService.flightOwDscType = service.flight && service.flight.onewayType || null
        tempService.flightOwDscRate = service.flight && service.flight.onewayRate || null
        tempService.flightRtDscType = service.flight && service.flight.roundtripType || null
        tempService.flightRtDscRate = service.flight && service.flight.roundtripRate || null
        if (service.future.portalFee) tempService.portalFee = service.future.portalFee || null
        if (service.future.portalFeeType) tempService.portalFeeType = service.future.portalFeeType || null
        if (typeof tempService.gasFee === 'string') delete tempService.gasFee
        // if (!tempService.gasFee) tempService.gasFee = 0

        if (forGlobal) {
          Object.keys(tempService).forEach(key => {
            if (tempService[key] === '') {
              delete tempService[key]
            }
          })
          // if (!tempService.pickupTypes.length) {
          //   delete tempService.pickupTypes
          // }
          delete tempService.pickupTypes
          pricingStore.global.pickupTypes.forEach(pt => {
            if (service.id === pt.id) {
              if (pt.pickupTypes.Curbside && pt.pickupTypes.Curbside.enabled !== '') {
                if (!tempService.pickupTypes) tempService.pickupTypes = []
                tempService.pickupTypes.push({name: 'Curbside', enabled: pt.pickupTypes.Curbside.enabled})
              }
              if (pt.pickupTypes.MeetAndGreet) {
                let tmpObj = ''
                if (pt.pickupTypes.MeetAndGreet.enabled !== '') {
                  tmpObj = {name: 'MeetAndGreet', enabled: pt.pickupTypes.MeetAndGreet.enabled}
                }
                if (pt.pickupTypes.MeetAndGreet.fee !== '') {
                  if (!tmpObj) tmpObj = {name: 'MeetAndGreet', fee: pt.pickupTypes.MeetAndGreet.fee}
                  else tmpObj.fee = pt.pickupTypes.MeetAndGreet.fee
                }
                if (tmpObj) {
                  if (!tempService.pickupTypes) tempService.pickupTypes = []
                  tempService.pickupTypes.push(tmpObj)
                }
              }
            }
          })
        }

        services.push(tempService)
      })
      if (serviceArea.discountStart) compiledData.discountStart = serviceArea.discountStart
      if (serviceArea.discountEnd) compiledData.discountEnd = serviceArea.discountEnd
      if (serviceArea.holidayDate) compiledData.holidayDate = serviceArea.holidayDate
      compiledData.holidayDate2 = serviceArea.holidayDate2 || null
      compiledData.holidayDate3 = serviceArea.holidayDate3 || null
      compiledData.holidayDate4 = serviceArea.holidayDate4 || null
      compiledData.holidayDate5 = serviceArea.holidayDate5 || null
      compiledData.holidayDate6 = serviceArea.holidayDate6 || null
      compiledData.holidayDate7 = serviceArea.holidayDate7 || null
      compiledData.holidayDate8 = serviceArea.holidayDate8 || null
      compiledData.holidayDate9 = serviceArea.holidayDate9 || null
      compiledData.holidayDate10 = serviceArea.holidayDate10 || null
      compiledData.discountWidget = serviceArea.discountWidget
      compiledData.discountAdmin = serviceArea.discountAdmin
      compiledData.discountApp = serviceArea.discountApp
      compiledData.discountCSR = serviceArea.discountCSR
    } else if (type === 'asap') {
      temp.forEach(service => {
        let tempService = {
          serviceTypeId: service.id,
          priority: service.priority,
          asapTravelInsurance: service.asap.travelInsurance,
          asapAirportFee: service.asap.airportFee,
          asapMileageRate: service.asap.mileageRate,
          asapFare: service.asap.fare,
          asapMileageThreshold: service.asap.mileageThreshold,
          asapFlat2paxFee: service.asap.flat2paxFee,
          asapFlatNpaxFee: service.asap.flatNpaxFee,
          asapDiscountType: service.asap.discountType,
          asapDiscountAmount: service.asap.discountAmount,
          asapRoundtripType: service.asap.roundtripType,
          asapRoundtripAmount: service.asap.roundtripAmount,
          asapProvMileage: service.asap.provMileage,
          asapProvBaseFee: service.asap.provBaseFee,
          asapProvBonus: service.asap.provBonus,
          asapProv2paxFee: service.asap.prov2paxFee,
          asapProvNpaxFee: service.asap.provNpaxFee,
          asapProvDiscountRate: service.asap.provDiscountRate,
          asapHolidayRateType: service.asap.holidayRateType,
          asapHolidayRateAmount: service.asap.holidayRateAmount
          // asapPortalFee: service.asap.portalFee,
          // asapPortalFeeType: service.asap.portalFeeType
          // asapGasFee: service.asap.gasFee || 0
        }
        if (typeof service.asap.gasFee === 'number') tempService.asapGasFee = service.asap.gasFee || 0
        if (typeof service.asap.portalFee === 'number') tempService.asapPortalFee = service.asap.portalFee || 0
        if (service.asap.portalFeeType) tempService.asapPortalFeeType = service.asap.portalFeeType

        if (serviceArea.asapDiscountStart) { tempService.asapDiscountStart = serviceArea.asapDiscountStart }
        if (serviceArea.asapDiscountEnd) { tempService.asapDiscountEnd = serviceArea.asapDiscountEnd }
        if (serviceArea.asapHolidayDate) { tempService.asapHolidayDate = serviceArea.asapHolidayDate }
        
        if (forGlobal) {
          Object.keys(tempService).forEach(key => {
            if (tempService[key] === '') {
              delete tempService[key]
            }
          })
        }

        services.push(tempService)
      })
      if (serviceArea.asapDiscountStart) compiledData.asapDiscountStart = serviceArea.asapDiscountStart
      if (serviceArea.asapDiscountEnd) compiledData.asapDiscountEnd = serviceArea.asapDiscountEnd
      if (serviceArea.asapHolidayDate) compiledData.asapHolidayDate = serviceArea.asapHolidayDate
      compiledData.asapHolidayDate2 = serviceArea.asapHolidayDate2 || null
      compiledData.asapHolidayDate3 = serviceArea.asapHolidayDate3 || null
      compiledData.asapHolidayDate4 = serviceArea.asapHolidayDate4 || null
      compiledData.asapHolidayDate5 = serviceArea.asapHolidayDate5 || null
      compiledData.asapHolidayDate6 = serviceArea.asapHolidayDate6 || null
      compiledData.asapHolidayDate7 = serviceArea.asapHolidayDate7 || null
      compiledData.asapHolidayDate8 = serviceArea.asapHolidayDate8 || null
      compiledData.asapHolidayDate9 = serviceArea.asapHolidayDate9 || null
      compiledData.asapHolidayDate10 = serviceArea.asapHolidayDate10 || null
      compiledData.asapDiscountWidget = serviceArea.asapDiscountWidget
      compiledData.asapDiscountAdmin = serviceArea.asapDiscountAdmin
      compiledData.asapDiscountApp = serviceArea.asapDiscountApp
      compiledData.asapDiscountCSR = serviceArea.asapDiscountCSR
    } else if (type === 'rental') {
      temp.forEach((service, index) => {
        let rental = service.rental
        let tempService = {
          serviceTypeId: service.id,
          enabled: true,
          rentFare: rental.rentFare,
          rentRate: rental.rentRate,
          rentRateDaily: rental.rentRateDaily,
          rentRateWeekend: rental.rentRateWeekend
        }

        if (forGlobal) {
          Object.keys(tempService).forEach(key => {
            if (tempService[key] === '') {
              delete tempService[key]
            }
          })
        }

        services.push(tempService)
      })
    } else {
      temp.forEach((service, index) => {
        let future = service.future
        let tempService = {
          serviceTypeId: service.id,
          enabled: true,
          airportFee: future.airportFee,
          discountAmount: future.discountAmount,
          discountType: '%',
          charterFare: service.charter.fare,
          minuteRate: service.charter.minuteRate,
          provCharterBase: service.charter.provBase,
          provCharterRate: service.charter.provRate,
          provCharterDiscount: service.charter.provDiscount
        }

        if (service.future.portalFee) tempService.portalFee = service.future.portalFee || null
        if (service.future.portalFeeType) tempService.portalFeeType = service.future.portalFeeType || null
        let tempPickupTypes = []
        for (let key in service.pickupTypes) {
          if (key !== 'null' && key !== 'enabled') {
            if (temp[index].pickupTypes[key].fee !== '' && temp[index].pickupTypes[key].fee !== null) {
              let tempPickupType = temp[index].pickupTypes[key]
              if (forGlobal) {
                delete tempPickupType.enabled
              }
              tempPickupTypes.push(tempPickupType)
            }
          }
        }
        tempService.pickupTypes = tempPickupTypes

        if (forGlobal) {
          Object.keys(tempService).forEach(key => {
            if (tempService[key] === '') {
              delete tempService[key]
            }
          })
          if (!tempService.pickupTypes.length) {
            delete tempService.pickupTypes
          }
          pricingStore.global.pickupTypesCharter.forEach(pt => {
            if (service.id === pt.id) {
              if (pt.pickupTypes.Curbside && pt.pickupTypes.Curbside.enabled !== '') {
                if (!tempService.pickupTypes) tempService.pickupTypes = []
                tempService.pickupTypes.push({name: 'Curbside', enabled: pt.pickupTypes.Curbside.enabled})
              }
              if (pt.pickupTypes.MeetAndGreet) {
                let tmpObj = ''
                if (pt.pickupTypes.MeetAndGreet.enabled !== '') {
                  tmpObj = {name: 'MeetAndGreet', enabled: pt.pickupTypes.MeetAndGreet.enabled}
                }
                if (pt.pickupTypes.MeetAndGreet.fee !== '') {
                  if (!tmpObj) tmpObj = {name: 'MeetAndGreet', fee: pt.pickupTypes.MeetAndGreet.fee}
                  else tmpObj.fee = pt.pickupTypes.MeetAndGreet.fee
                }
                if (tmpObj) {
                  if (!tempService.pickupTypes) tempService.pickupTypes = []
                  tempService.pickupTypes.push(tmpObj)
                }
              }
            }
          })
        }

        services.push(tempService)
      })
      if (serviceArea.charterDiscountStart) compiledData.discountStart = serviceArea.charterDiscountStart
      if (serviceArea.charterDiscountEnd) compiledData.discountEnd = serviceArea.charterDiscountEnd
      if (serviceArea.charterHolidayDate) compiledData.holidayDate = serviceArea.charterHolidayDate
      compiledData.holidayDate2 = serviceArea.charterHolidayDate2 || null
      compiledData.holidayDate3 = serviceArea.charterHolidayDate3 || null
      compiledData.holidayDate4 = serviceArea.charterHolidayDate4 || null
      compiledData.holidayDate5 = serviceArea.charterHolidayDate5 || null
      compiledData.holidayDate6 = serviceArea.charterHolidayDate6 || null
      compiledData.holidayDate7 = serviceArea.charterHolidayDate7 || null
      compiledData.holidayDate8 = serviceArea.charterHolidayDate8 || null
      compiledData.holidayDate9 = serviceArea.charterHolidayDate9 || null
      compiledData.holidayDate10 = serviceArea.charterHolidayDate10 || null
    }
    compiledData.services = services

    let origData = pricingStore.originalData
    let conf = CONFIG.brands.find(x => x.id === VueApp.$store.state.pricing.brandId)
    if (type === 'asap') {
      if (origData[0]) {
        if (compiledData.asapDiscountAdmin === origData[0].asap.discountAdmin) delete compiledData.asapDiscountAdmin
        if (compiledData.asapDiscountApp === origData[0].asap.discountApp) delete compiledData.asapDiscountApp
        if (compiledData.asapDiscountWidget === origData[0].asap.discountWidget) delete compiledData.asapDiscountWidget
        if (compiledData.asapDiscountCSR === origData[0].asap.discountCSR) delete compiledData.asapDiscountCSR
        if (compiledData.asapDiscountStart === origData[0].asap.discountStart) delete compiledData.asapDiscountStart
        if (compiledData.asapDiscountEnd === origData[0].asap.discountEnd) delete compiledData.asapDiscountEnd
        if (compiledData.asapHolidayDate === origData[0].asap.holidayDate) delete compiledData.asapHolidayDate
        if (compiledData.asapHolidayDate2 === origData[0].asap.holidayDate2) delete compiledData.asapHolidayDate2
        if (compiledData.asapHolidayDate3 === origData[0].asap.holidayDate3) delete compiledData.asapHolidayDate3
        if (compiledData.asapHolidayDate4 === origData[0].asap.holidayDate4) delete compiledData.asapHolidayDate4
        if (compiledData.asapHolidayDate5 === origData[0].asap.holidayDate5) delete compiledData.asapHolidayDate5
        if (compiledData.asapHolidayDate6 === origData[0].asap.holidayDate6) delete compiledData.asapHolidayDate6
        if (compiledData.asapHolidayDate7 === origData[0].asap.holidayDate7) delete compiledData.asapHolidayDate7
        if (compiledData.asapHolidayDate8 === origData[0].asap.holidayDate8) delete compiledData.asapHolidayDate8
        if (compiledData.asapHolidayDate9 === origData[0].asap.holidayDate9) delete compiledData.asapHolidayDate9
        if (compiledData.asapHolidayDate10 === origData[0].asap.holidayDate10) delete compiledData.asapHolidayDate10
      }

      let noChanges = []
      if (!forGlobal) {
        compiledData.services.forEach((service, i) => {
          let origService = origData.find(x => x.id === service.serviceTypeId)
          for (let key in service) {
            if (['serviceTypeId', 'priority'].indexOf(key) > -1) continue
            let tmpKey = key.slice(4)
            tmpKey = `${tmpKey.charAt(0).toLowerCase()}${tmpKey.slice(1)}`
            if (service[key] === origService.asap[tmpKey]) delete compiledData.services[i][key]
          }
          if (Object.keys(service).length === 2) noChanges.push(service.serviceTypeId)
        })

        // Delete services with no changes
        noChanges.forEach(x => {
          let index = compiledData.services.findIndex(xx => xx.serviceTypeId === x)
          if (index > -1 ) compiledData.services.splice(index, 1)
        })
      }
    } else if (type === 'future') {
      if (origData[0]) {
        if (compiledData.discountAdmin === origData[0].future.discountAdmin) delete compiledData.discountAdmin
        if (compiledData.discountApp === origData[0].future.discountApp) delete compiledData.discountApp
        if (compiledData.discountWidget === origData[0].future.discountWidget) delete compiledData.discountWidget
        if (compiledData.discountCSR === origData[0].future.discountCSR) delete compiledData.discountCSR
        if (compiledData.discountStart === origData[0].future.discountStart) delete compiledData.discountStart
        if (compiledData.discountEnd === origData[0].future.discountEnd) delete compiledData.discountEnd
        if (compiledData.holidayDate === origData[0].future.holidayDate) delete compiledData.holidayDate
        if (compiledData.holidayDate2 === origData[0].future.holidayDate2) delete compiledData.holidayDate2
        if (compiledData.holidayDate3 === origData[0].future.holidayDate3) delete compiledData.holidayDate3
        if (compiledData.holidayDate4 === origData[0].future.holidayDate4) delete compiledData.holidayDate4
        if (compiledData.holidayDate5 === origData[0].future.holidayDate5) delete compiledData.holidayDate5
        if (compiledData.holidayDate6 === origData[0].future.holidayDate6) delete compiledData.holidayDate6
        if (compiledData.holidayDate7 === origData[0].future.holidayDate7) delete compiledData.holidayDate7
        if (compiledData.holidayDate8 === origData[0].future.holidayDate8) delete compiledData.holidayDate8
        if (compiledData.holidayDate9 === origData[0].future.holidayDate9) delete compiledData.holidayDate9
        if (compiledData.holidayDate10 === origData[0].future.holidayDate10) delete compiledData.holidayDate10
      }

      let noChanges = []
      if (!forGlobal) {
        compiledData.services.forEach((service, i) => {
          let origService = origData.find(x => x.id === service.serviceTypeId)
          for (let key in service) {
            if (['serviceTypeId'].indexOf(key) > -1) continue
            if (service[key] === origService.future[key]) delete compiledData.services[i][key]
          }
  
          // check if D2D
          if (conf && conf.code === 'd2d') {
            if (service.flightOwDscRate === origService.flight.oneway.rate) delete compiledData.services[i].flightOwDscRate
            if (service.flightOwDscType === origService.flight.oneway.type) delete compiledData.services[i].flightOwDscType
            if (service.flightRtDscRate === origService.flight.roundtrip.rate) delete compiledData.services[i].flightRtDscRate
            if (service.flightRtDscType === origService.flight.roundtrip.type) delete compiledData.services[i].flightRtDscType
          } else {
            delete compiledData.services[i].flightOwDscRate
            delete compiledData.services[i].flightOwDscType
            delete compiledData.services[i].flightRtDscRate
            delete compiledData.services[i].flightRtDscType
          }
  
          // check Pickup Types
          let removePickpType = {}
          service.pickupTypes.forEach(pickupType => {
            if (!removePickpType[service.serviceTypeId]) removePickpType[service.serviceTypeId] = []
            if (!origService.pickupTypes.length) return
            let origCurbside = origService.pickupTypes.find(x => x.name === 'Curbside')
            let origMeetAndGreet = origService.pickupTypes.find(x => x.name === 'MeetAndGreet')
            if (pickupType.name === 'Curbside' && pickupType.enabled === origCurbside.enabled) {
              removePickpType[service.serviceTypeId].push('Curbside')
            }
            if (pickupType.name === 'MeetAndGreet' && pickupType.enabled === origMeetAndGreet.enabled && pickupType.fee === origMeetAndGreet.fee) {
              removePickpType[service.serviceTypeId].push('MeetAndGreet')
            }
          })
          for (let key in removePickpType) {
            if (removePickpType[key].length) {
              removePickpType[key].forEach(puType => {
                let puIndex = service.pickupTypes.findIndex(x => x.name === puType)
                if (puIndex > -1) compiledData.services[i].pickupTypes.splice(puIndex, 1)
              })
            }
          }
          if (!compiledData.services[i].pickupTypes.length) delete compiledData.services[i].pickupTypes
  
          if (Object.keys(service).length === 1) noChanges.push(service.serviceTypeId)
        })

        // Delete services with no changes
        noChanges.forEach(x => {
          let index = compiledData.services.findIndex(xx => xx.serviceTypeId === x)
          if (index > -1 ) compiledData.services.splice(index, 1)
        })
      }

    } else if (type === 'charter') {
      if (origData[0]) {
        if (compiledData.discountStart === origData[0].future.discountStart) delete compiledData.discountStart
        if (compiledData.discountEnd === origData[0].future.discountEnd) delete compiledData.discountEnd
        if (compiledData.holidayDate === origData[0].future.holidayDate) delete compiledData.holidayDate
        if (compiledData.holidayDate2 === origData[0].future.holidayDate2) delete compiledData.holidayDate2
        if (compiledData.holidayDate3 === origData[0].future.holidayDate3) delete compiledData.holidayDate3
        if (compiledData.holidayDate4 === origData[0].future.holidayDate4) delete compiledData.holidayDate4
        if (compiledData.holidayDate5 === origData[0].future.holidayDate5) delete compiledData.holidayDate5
        if (compiledData.holidayDate6 === origData[0].future.holidayDate6) delete compiledData.holidayDate6
        if (compiledData.holidayDate7 === origData[0].future.holidayDate7) delete compiledData.holidayDate7
        if (compiledData.holidayDate8 === origData[0].future.holidayDate8) delete compiledData.holidayDate8
        if (compiledData.holidayDate9 === origData[0].future.holidayDate9) delete compiledData.holidayDate9
        if (compiledData.holidayDate10 === origData[0].future.holidayDate10) delete compiledData.holidayDate10
      }

      let noChanges = []
      if (!forGlobal) {
        compiledData.services.forEach((service, i) => {
          let origService = origData.find(x => x.id === service.serviceTypeId)

          if (service.airportFee === origService.future.airportFee) delete compiledData.services[i].airportFee
          if (service.discountAmount === origService.future.discountAmount) delete compiledData.services[i].discountAmount
          if (service.discountType === origService.future.discountType) delete compiledData.services[i].discountType
          if (service.minuteRate === origService.charter.minuteRate) delete compiledData.services[i].minuteRate
          if (service.charterFare === origService.charter.fare) delete compiledData.services[i].charterFare
          if (service.provCharterBase === origService.charter.provBase) delete compiledData.services[i].provCharterBase
          if (service.provCharterRate === origService.charter.provRate) delete compiledData.services[i].provCharterRate
          if (service.provCharterDiscount === origService.charter.provDiscount) delete compiledData.services[i].provCharterDiscount

          // check Pickup Types
          let removePickpType = {}
          service.pickupTypes.forEach(pickupType => {
            if (!removePickpType[service.serviceTypeId]) removePickpType[service.serviceTypeId] = []
            let origCurbside = origService.pickupTypes.find(x => x.name === 'Curbside')
            let origMeetAndGreet = origService.pickupTypes.find(x => x.name === 'MeetAndGreet')
            if (pickupType.name === 'Curbside' && origCurbside && pickupType.enabled === origCurbside.enabled) {
              removePickpType[service.serviceTypeId].push('Curbside')
            }
            if (pickupType.name === 'MeetAndGreet' && origMeetAndGreet && pickupType.enabled === origMeetAndGreet.enabled && pickupType.fee === origMeetAndGreet.fee) {
              removePickpType[service.serviceTypeId].push('MeetAndGreet')
            }
          })
          for (let key in removePickpType) {
            if (removePickpType[key].length) {
              removePickpType[key].forEach(puType => {
                let puIndex = service.pickupTypes.findIndex(x => x.name === puType)
                if (puIndex > -1) compiledData.services[i].pickupTypes.splice(puIndex, 1)
              })
            }
          }
          if (!compiledData.services[i].pickupTypes.length) delete compiledData.services[i].pickupTypes

          if (Object.keys(service).length === 2) noChanges.push(service.serviceTypeId)
        })

        // Delete services with no changes
        noChanges.forEach(x => {
          let index = compiledData.services.findIndex(xx => xx.serviceTypeId === x)
          if (index > -1 ) compiledData.services.splice(index, 1)
        })
      }
    } else if (type === 'rental') {
      let noChanges = []
      if (!forGlobal) {
        compiledData.services.forEach((service, i) => {
          let origService = origData.find(x => x.id === service.serviceTypeId)

          if (service.rentFare === origService.rental.rentFare) delete compiledData.services[i].rentFare
          if (service.rentRate === origService.rental.rentRate) delete compiledData.services[i].rentRate
          if (service.rentRateDaily === origService.rental.rentRateDaily) delete compiledData.services[i].rentRateDaily
          if (service.rentRateWeekend === origService.rental.rentRateWeekend) delete compiledData.services[i].rentRateWeekend

          if (Object.keys(service).length === 2) noChanges.push(service.serviceTypeId)
        })

        // Delete services with no changes
        noChanges.forEach(x => {
          let index = compiledData.services.findIndex(xx => xx.serviceTypeId === x)
          if (index > -1 ) compiledData.services.splice(index, 1)
        })
      }
    }
    return compiledData
  }
}


// WEBPACK FOOTER //
// ./src/modules/api/pricing/service-types.js